const $ = jQuery;
class Linkable {
	constructor(el){
		this.el = el;
		this.a = this.el.querySelector('a');
		if( !this.a ){
			return;
		}
		this.link = this.a.href;
		this.target = this.a.target;
		this.el.style.cursor = 'pointer';
		$(this.el).on('click', e => {
			e.preventDefault();
			if( !this.target || this.target == '_self' ){
				window.location = this.link;
			}
			else {
				window.open(this.link, this.target);
			}
		});
	}
	
}

export default {
	init(el){
		new Linkable(el);
	}
}